module.exports = __webpack_public_path__ + "static/media/overlay.b6dc8d2b.svg";